var _rect, _path, _path2, _g, _rect2, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_0_104)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_104)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12.5238,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.05
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.5,
    filter: "url(#filter1_f_0_104)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8944 34.5238C24.2769 34.5238 22.7691 34.0533 21.5 33.2416C22.5775 33.3113 24.479 33.1444 25.6618 32.0162C23.8825 31.9346 23.0801 30.5699 22.9755 29.9868C23.1266 30.0451 23.8477 30.1151 24.2547 29.9518C22.2079 29.4386 21.894 27.6425 21.9637 27.0943C22.3475 27.3625 22.9987 27.4559 23.2546 27.4325C21.3474 26.0679 22.0335 24.0152 22.3708 23.572C23.7394 25.4681 25.7906 26.5331 28.3282 26.5923C28.2803 26.3825 28.2551 26.164 28.2551 25.9396C28.2551 24.3293 29.5567 23.0238 31.1623 23.0238C32.0013 23.0238 32.7572 23.3802 33.2878 23.9502C33.8485 23.8189 34.6922 23.5113 35.1046 23.2454C34.8967 23.9919 34.2495 24.6145 33.858 24.8453C33.8548 24.8375 33.8612 24.8532 33.858 24.8453C34.2019 24.7933 35.1324 24.6145 35.5 24.3651C35.3182 24.7844 34.632 25.4817 34.0689 25.872C34.1736 30.4928 30.6382 34.5238 25.8944 34.5238Z",
    fill: "#00A9FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8944 34.5238C24.2769 34.5238 22.7691 34.0533 21.5 33.2416C22.5775 33.3113 24.479 33.1444 25.6618 32.0162C23.8825 31.9346 23.0801 30.5699 22.9755 29.9868C23.1266 30.0451 23.8477 30.1151 24.2547 29.9518C22.2079 29.4386 21.894 27.6425 21.9637 27.0943C22.3475 27.3625 22.9987 27.4559 23.2546 27.4325C21.3474 26.0679 22.0335 24.0152 22.3708 23.572C23.7394 25.4681 25.7906 26.5331 28.3282 26.5923C28.2803 26.3825 28.2551 26.164 28.2551 25.9396C28.2551 24.3293 29.5567 23.0238 31.1623 23.0238C32.0013 23.0238 32.7572 23.3802 33.2878 23.9502C33.8485 23.8189 34.6922 23.5113 35.1046 23.2454C34.8967 23.9919 34.2495 24.6145 33.858 24.8453C33.8548 24.8375 33.8612 24.8532 33.858 24.8453C34.2019 24.7933 35.1324 24.6145 35.5 24.3651C35.3182 24.7844 34.632 25.4817 34.0689 25.872C34.1736 30.4928 30.6382 34.5238 25.8944 34.5238Z",
    fill: "#47ACDF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_0_104)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5,
    cy: 40.0238,
    rx: 11.5,
    ry: 6.5,
    fill: "#11B0FF"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 12.6238,
    width: 31.8,
    height: 31.8,
    rx: 15.9,
    stroke: "url(#paint0_radial_0_104)",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#filter3_f_0_104)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29.5238,
    r: 9,
    fill: "white",
    fillOpacity: 0.18
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_104",
    x: 2,
    y: 2.5238,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_104",
    x: 8,
    y: 8.5238,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_0_104"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_0_104",
    x: -4,
    y: 15.5238,
    width: 59,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "effect1_foregroundBlur_0_104"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_0_104",
    x: 0,
    y: 0.523804,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_0_104"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_104",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2878 13.4759) rotate(44.0741) scale(43.4569 69.503)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_104"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12.5238,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.69600e5930135b1b47ad8d4abe04f9d4.svg";
export { ForwardRef as ReactComponent };